module.exports = __webpack_public_path__ + "img/loginbk.74eaa6d3.png";